import { observable, makeObservable } from 'mobx'

export class SettingsStore {
  constructor () {
    makeObservable(this, {
      _uploadFilesCount: observable,
      _maxFileSize: observable,
      _personBorderOffsetPercent: observable
    })
  }

  _uploadFilesCount = Number(sessionStorage.getItem('uploadFilesCount')) || 20

  get uploadFilesCount () {
    return this._uploadFilesCount
  }

  set uploadFilesCount (value) {
    this._uploadFilesCount = value
    sessionStorage.setItem('uploadFilesCount', value)
  }

  _maxFileSize = Number(sessionStorage.getItem('maxFileSize')) || 5

  get maxFileSize () {
    return this._maxFileSize
  }

  set maxFileSize (value) {
    this._maxFileSize = value
    sessionStorage.setItem('maxFileSize', value)
  }

  _personBorderOffsetPercent = Number(sessionStorage.getItem('personBorderOffsetPercent')) || 20

  get personBorderOffsetPercent () {
    return this._personBorderOffsetPercent
  }

  set personBorderOffsetPercent (value) {
    this._personBorderOffsetPercent = value
    sessionStorage.setItem('personBorderOffsetPercent', value)
  }
}
